const STYLES = {
  "Pending": "bg-slate-100 border-slate-300/80 text-slate-700",
  "In Progress": "bg-orange-50 border-orange-300/80 text-orange-900",
  "Completed": "bg-emerald-50 border-emerald-300/80 text-emerald-900",
  "Skipped": "bg-rose-50 border-rose-300/80 text-rose-900",
};

const DOTS = {
  "Pending": "bg-slate-400",
  "In Progress": "bg-orange-500",
  "Completed": "bg-emerald-600",
  "Skipped": "bg-rose-500",
};

export default function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${status.toLowerCase().replace(" ", "-")}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg border text-xs font-medium uppercase tracking-wider ${STYLES[status] || STYLES["Pending"]}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${DOTS[status] || DOTS["Pending"]}`} />
      {status}
    </span>
  );
}
